'use strict';

(function () {

  var STORAGE_KEY = 'ztrak_vehicle';

  var FitmentStorage = {
    _memory: null, // session-only fallback when localStorage is unavailable (iOS private)

    _canUseStorage: function () {
      try {
        localStorage.setItem('__ztrak_test', '1');
        localStorage.removeItem('__ztrak_test');
        return true;
      } catch (e) {
        return false;
      }
    },

    getVehicle: function () {
      try {
        var raw = FitmentStorage._canUseStorage()
          ? localStorage.getItem(STORAGE_KEY)
          : (FitmentStorage._memory ? JSON.stringify(FitmentStorage._memory) : null);
        if (!raw) return null;
        return JSON.parse(raw);
      } catch (e) {
        return null;
      }
    },

    saveVehicle: function (year, make, model, fitment) {
      var vehicle = {
        year: year,
        make: make,
        model: model,
        fitment: fitment,
        savedAt: Date.now()
      };
      try {
        if (FitmentStorage._canUseStorage()) {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(vehicle));
        } else {
          FitmentStorage._memory = vehicle;
        }
      } catch (e) {
        FitmentStorage._memory = vehicle;
      }
      FitmentStorage._syncCartAttributes(vehicle);
      document.dispatchEvent(new CustomEvent('ymm:confirmed', { detail: { vehicle: vehicle } }));
      document.dispatchEvent(new CustomEvent('ymm:changed',   { detail: { vehicle: vehicle } }));
    },

    clearVehicle: function () {
      try {
        if (FitmentStorage._canUseStorage()) {
          localStorage.removeItem(STORAGE_KEY);
        } else {
          FitmentStorage._memory = null;
        }
      } catch (e) {
        FitmentStorage._memory = null;
      }
      FitmentStorage._syncCartAttributes(null);
      document.dispatchEvent(new CustomEvent('ymm:cleared', { detail: { vehicle: null } }));
      document.dispatchEvent(new CustomEvent('ymm:changed',  { detail: { vehicle: null } }));
    },

    _syncCartAttributes: function (vehicle) {
      var attributes = vehicle
        ? {
            'truck-year':     vehicle.year,
            'truck-make':     vehicle.make,
            'truck-model':    vehicle.model,
            'fitment-status': vehicle.fitment ? vehicle.fitment.status : '',
            'fitment-sku':    vehicle.fitment ? vehicle.fitment.sku   : ''
          }
        : {
            'truck-year': '', 'truck-make': '', 'truck-model': '',
            'fitment-status': '', 'fitment-sku': ''
          };

      fetch(theme.routes.cart_update_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }).catch(function (err) {
        console.warn('[FitmentStorage] Cart attribute sync failed:', err);
      });
    },

    restoreOnLoad: function () {
      var vehicle = FitmentStorage.getVehicle();
      if (vehicle) {
        document.dispatchEvent(new CustomEvent('ymm:resolved', { detail: { vehicle: vehicle } }));
        document.dispatchEvent(new CustomEvent('ymm:changed',  { detail: { vehicle: vehicle } }));
      }
    }
  };

  window.FitmentStorage = FitmentStorage;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { FitmentStorage.restoreOnLoad(); });
  } else {
    FitmentStorage.restoreOnLoad();
  }

})();
